export const gtagConfig = {
  RJZA: 'G-JG2V2GJBWZ',
  FJZA: 'G-826QEJB5LE',
  JGH: 'G-SETZJGK1VV',
  JMW: 'G-XZWBQTYZ34',
  JTZ: 'G-CHYKQFL5CX',
  JZA: 'G-NMPQQWDWTH',
};

export const srConfig = {
  JMW: 'STM-AAAA5L',
  JTZ: 'STM-AAAA5K',
  JZA: 'STM-AAAA3Q',
};

export const tdConfig = {
  JGH: 'tx0qjje',
  JMW: '0qoq52f',
  JTZ: '6f2sr9l',
  JZA: 'zsmx1m5',
};
export const tdPixels = {
  JGH: {
    pageView: 'arpclvj',
    login: 'hz16acm',
    regEngaged: 'os1jycf',
    regCompleted: '0g72agr',
  },
  JMW: {
    pageView: '20agk6k',
    login: 'j7xl3mr',
    regEngaged: '4klyjp7',
    regCompleted: 'ua9bk7s',
  },
  JTZ: {
    pageView: 'tgh5dln',
    login: '5p42rzt',
    regEngaged: '7t11y2f',
    regCompleted: 'kfppnzm',
  },
  JZA: {
    pageView: 'j2d26y3',
    login: 'jo3wpe7',
    regEngaged: '2ewti1i',
    regCompleted: '2t18ekk',
  },
};

export const ftConfig = {
  JGH: '36349',
  JMW: '34057',
  JTZ: '34058',
  JZA: '28976',
};
export const ftSpotlightId = {
  JGH: {
    pageView: '150581',
    login: '150585',
    regEngaged: '150582',
    regCompleted: '150584',
  },
  JMW: {
    pageView: '146868',
    login: '146872',
    regEngaged: '146869',
    regCompleted: '146871',
  },
  JTZ: {
    pageView: '146875',
    login: '146879',
    regEngaged: '146876',
    regCompleted: '146878',
  },
  JZA: {
    pageView: '144648',
    login: '140835',
    regEngaged: '140836',
    regCompleted: '140842',
  },
};
export const ftSpotlightGroup = {
  JGH: {
    pageView: '17492',
    login: '17494',
    regEngaged: '17493',
    regCompleted: '17494',
  },
  JMW: {
    pageView: '16884',
    login: '16886',
    regEngaged: '16885',
    regCompleted: '16886',
  },
  JTZ: {
    pageView: '16888',
    login: '16890',
    regEngaged: '16889',
    regCompleted: '16890',
  },
  JZA: {
    pageView: '16508',
    login: '15919',
    regEngaged: '15920',
    regCompleted: '15919',
  },
};
export const ftSpotlightName = {
  login: 'LOGIN',
  regEngaged: 'Registration_Initiated',
  regCompleted: 'REGISTRATION_SUCCESS',
};

export const metaConfig = {
  JGH: '1379405367363361',
  JMW: '785532103845234',
  JTZ: '1423821932073321',
  JZA: '1534520261045252',
};
